/**
 * @file: 顶板组件销毁
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent } from '../../message/index';

function roofDestroy(cube: CubeNode): boolean {
    StageEvent.unbind(['changeRenderMode', 'tagsChangeSetting', 'changeSetting'], cube.id);
    return true;
}

export default roofDestroy;
